import { render, staticRenderFns } from "./dialogForm.vue?vue&type=template&id=96e01ff4&scoped=true"
import script from "./dialogForm.vue?vue&type=script&lang=js"
export * from "./dialogForm.vue?vue&type=script&lang=js"
import style0 from "./dialogForm.vue?vue&type=style&index=0&id=96e01ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e01ff4",
  null
  
)

export default component.exports